// removed by extract-text-webpack-plugin
module.exports = {"root":"section-title--root--3Salsuut","title":"section-title--title--2yQ895FS","action":"section-title--action--2Q-nAP78","subtitle":"section-title--subtitle--35IzWOW0"};


//////////////////
// WEBPACK FOOTER
// ./components/section-title/styles.css
// module id = ./components/section-title/styles.css
// module chunks = 0